import { render, staticRenderFns } from "./BadgeOrder.vue?vue&type=template&id=49cdbbb4"
import script from "./BadgeOrder.vue?vue&type=script&lang=js"
export * from "./BadgeOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports